import React from "react";
import { FaSolarPanel, FaRupeeSign, FaLeaf, FaCheckCircle } from "react-icons/fa";

const RooftopSolar = () => {
  const whatsappNumber = "+918239696960";
  const preFilledMessage = encodeURIComponent(
    "Hello, I am interested in Rooftop Solar Solutions. Please provide more details."
  );

  return (
    <section className="rooftop-page">
      {/* Hero Section */}
      <div className="rooftop-hero py-4">
        <div className="hero-content">
          <div className="hero-icon">
            <FaSolarPanel />
          </div>
          <h1>Rooftop Solar Solutions</h1>
          <p>Clean, reliable & cost-effective solar power for homes and businesses</p>

        </div>
      </div>

      <div className="rooftop-container">
        <div className="section-header">
          <h2>Why Choose Rooftop Solar</h2>
          <p>Transform your rooftop into a power generation asset with minimal investment</p>
        </div>

        <div className="rt-grid">
          <div className="rt-card">
            <div className="card-icon">
              <FaRupeeSign />
            </div>
            <h3>Save up to 80% on Bills</h3>
            <p>Solar drastically lowers your monthly electricity expenses with predictable energy costs for decades</p>
          </div>

          <div className="rt-card">
            <div className="card-icon">
              <FaLeaf />
            </div>
            <h3>Eco-Friendly Energy</h3>
            <p>Reduce your carbon footprint by generating clean, renewable energy and contributing to a sustainable future</p>
          </div>

          <div className="rt-card">
            <div className="card-icon">
              <FaSolarPanel />
            </div>
            <h3>Government Subsidy</h3>
            <p>Up to 40% subsidy available for residential solar setups with easy application process</p>
          </div>
        </div>

        <div className="rt-benefits">


          {/* WhatsApp Button */}
          <a
            className="whatsapp-contact"
            href={`https://wa.me/${whatsappNumber}?text=${preFilledMessage}`}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Contact via WhatsApp"
          >
            Talk to Our Expert
          </a>
        </div>
      </div>

      {/* Inline CSS */}
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        
        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .rooftop-page {
          font-family: 'Poppins', sans-serif;
          color: #333;
          overflow-x: hidden;
        }

        /* Hero Section */
        .rooftop-hero {
          background: linear-gradient(135deg, #0047AB, #a1c5ebff);
          color: white;
          text-align: center;
          padding: 2px 5px;
          position: relative;
          overflow: hidden;
        }

        .hero-content {
          max-width: 900px;
          margin: 0 auto;
          position: relative;
          z-index: 2;
        }

        .hero-icon {
          font-size: 3rem;
          margin-bottom: 20px;
          opacity: 0.9;
        }

        .rooftop-hero h1 {
          font-size: 2.8rem;
          font-weight: 700;
          margin-bottom: 15px;
        }

        .rooftop-hero p {
          font-size: 1.2rem;
          margin-bottom: 20px; /* Reduced from 30px */
          max-width: 700px;
          margin-left: auto;
          margin-right: auto;
        }

        .hero-stats {
          display: flex;
          justify-content: center;
          gap: 40px;
          margin-top: 10px; /* Reduced from 20px */
        }

        .stat {
          text-align: center;
          background: #4a8acaff; /* Changed to navy blue */
          padding: 10px 15px; /* Reduced from 15px 20px */
          border-radius: 12px;
          backdrop-filter: blur(5px);
          transition: all 0.3s ease;
        }

        .stat:hover {
          transform: translateY(-5px);
          background: #002E5D; /* Darker navy blue on hover */
        }

        .stat-number {
          display: block;
          font-size: 1.8rem; /* Reduced from 2.2rem */
          font-weight: 700;
          line-height: 1;
          color: white;
        }

        .stat-label {
          font-size: 0.8rem; /* Reduced from 0.9rem */
          opacity: 0.9;
        }

        /* Main Content */
        .rooftop-container {
          max-width: 1200px;
          margin: 60px auto;
          padding: 0 20px;
        }

        .section-header {
          text-align: center;
          margin-bottom: 50px;
        }

        .section-header h2 {
          font-size: 2.2rem;
          color: #0047AB;
          margin-bottom: 15px;
          font-weight: 700;
          position: relative;
          display: inline-block;
        }

        .section-header h2::after {
          content: '';
          position: absolute;
          bottom: -10px;
          left: 50%;
          transform: translateX(-50%);
          width: 80px;
          height: 3px;
          background: linear-gradient(90deg, #0047AB, #007BFF);
          border-radius: 2px;
        }

        .section-header p {
          font-size: 1.1rem;
          max-width: 700px;
          margin: 20px auto 0;
        }

        /* Cards Grid */
        .rt-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
          gap: 30px;
          margin-bottom: 20px;
        }

        .rt-card {
          background: white;
          padding: 30px;
          border-radius: 16px;
          box-shadow: 0 8px 25px rgba(0, 71, 171, 0.08);
          text-align: center;
          transition: all 0.3s ease;
        }

        .rt-card:hover {
          transform: translateY(-10px);
          box-shadow: 0 15px 35px rgba(0, 71, 171, 0.15);
        }

        .card-icon {
          width: 70px;
          height: 70px;
          background: rgba(0, 71, 171, 0.1);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 20px;
          font-size: 1.8rem;
          color: white;
        }

        .rt-card h3 {
          color: #0047AB;
          margin-bottom: 15px;
          font-size: 1.3rem;
        }

        .rt-card p {
          color: #666;
          line-height: 1.6;
        }

        /* Benefits Section */
        .rt-benefits {
          background: #f8fbff;
          padding: 40px;
          border-radius: 16px;
          text-align: center;
        }

        .rt-benefits h2 {
          font-size: 2rem;
          color: #0047AB;
          margin-bottom: 30px;
          font-weight: 700;
        }

        .benefits-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
          gap: 20px;
          margin-bottom: 30px;
        }

        .benefit-item {
          display: flex;
          align-items: center;
          gap: 15px;
          background: white;
          padding: 15px 20px;
          border-radius: 12px;
          box-shadow: 0 4px 15px rgba(0, 71, 171, 0.05);
          text-align: left;
          transition: all 0.3s ease;
        }

        .benefit-item:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 20px rgba(0, 71, 171, 0.1);
        }

        .benefit-icon {
          color: #4CAF50;
          font-size: 1.2rem;
          flex-shrink: 0;
        }

        .benefit-item span {
          font-size: 1rem;
          color: #333;
        }

        /* WhatsApp Button */
        .whatsapp-contact {
          display: inline-block;
          background: #25d366;
          color: white;
          font-weight: 600;
          padding: 15px 30px;
          border-radius: 50px;
          text-decoration: none;
          box-shadow: 0 5px 20px rgba(37, 211, 102, 0.3);
          transition: all 0.3s ease;
          font-size: 1.1rem;
        }

        .whatsapp-contact:hover {
          transform: translateY(-3px);
          box-shadow: 0 8px 25px rgba(37, 211, 102, 0.4);
        }

        /* Responsive Design */
        /* Large Desktop */
        @media (min-width: 1400px) {
          .rooftop-container {
            max-width: 1320px;
          }
        }

        /* Desktop */
        @media (max-width: 1200px) {
          .rooftop-hero h1 {
            font-size: 2.5rem;
          }
          
          .hero-stats {
            gap: 30px;
          }
          
          .stat {
            padding: 8px 12px; /* Reduced padding */
          }
        }

        /* Tablet Landscape */
        @media (max-width: 992px) {
          .rooftop-hero {
            padding: 70px 20px;
          }
          
          .rooftop-hero h1 {
            font-size: 2.2rem;
          }
          
          .rooftop-hero p {
            font-size: 1.1rem;
          }
          
          .hero-icon {
            font-size: 2.5rem;
          }
          
          .hero-stats {
            gap: 20px;
          }
          
          .stat-number {
            font-size: 1.5rem; /* Reduced from 1.8rem */
          }
          
          .stat-label {
            font-size: 0.75rem; /* Reduced from 0.85rem */
          }
          
          .section-header h2 {
            font-size: 2rem;
          }
          
          .section-header p {
            font-size: 1rem;
          }
          
          .rt-grid {
            grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
            gap: 25px;
          }
          
          .rt-card {
            padding: 25px;
          }
          
          .card-icon {
            width: 60px;
            height: 60px;
            font-size: 1.6rem;
          }
          
          .rt-card h3 {
            font-size: 1.2rem;
          }
          
          .rt-benefits {
            padding: 35px;
          }
          
          .rt-benefits h2 {
            font-size: 1.8rem;
          }
          
          .benefit-item {
            padding: 12px 15px;
          }
        }

        /* Tablet Portrait */
        @media (max-width: 768px) {
          .rooftop-hero {
            padding: 60px 15px;
          }
          
          .rooftop-hero h1 {
            font-size: 2rem;
          }
          
          .rooftop-hero p {
            font-size: 1rem;
            margin-bottom: 20px; /* Reduced from 25px */
          }
          
          .hero-icon {
            font-size: 2.2rem;
            margin-bottom: 15px;
          }
          
          .hero-stats {
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: center;
            gap: 15px;
            margin-top: 10px; /* Reduced from 15px */
          }
          
          .stat {
            flex: 0 0 calc(33.333% - 10px);
            padding: 8px 12px; /* Reduced padding */
          }
          
          .stat-number {
            font-size: 1.4rem; /* Reduced from 1.6rem */
          }
          
          .stat-label {
            font-size: 0.7rem; /* Reduced from 0.8rem */
          }
          
          .rooftop-container {
            margin: 40px auto;
            padding: 0 15px;
          }
          
          .section-header {
            margin-bottom: 40px;
          }
          
          .section-header h2 {
            font-size: 1.8rem;
          }
          
          .section-header p {
            font-size: 0.95rem;
          }
          
          .rt-grid {
            grid-template-columns: 1fr;
            gap: 20px;
            margin-bottom: 40px;
          }
          
          .rt-card {
            padding: 20px;
          }
          
          .card-icon {
            width: 55px;
            height: 55px;
            font-size: 1.5rem;
            margin-bottom: 15px;
          }
          
          .rt-card h3 {
            font-size: 1.1rem;
          }
          
          .rt-card p {
            font-size: 0.9rem;
          }
          
          .rt-benefits {
            padding: 30px 20px;
          }
          
          .rt-benefits h2 {
            font-size: 1.6rem;
            margin-bottom: 25px;
          }
          
          .benefits-grid {
            grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
            gap: 15px;
            margin-bottom: 25px;
          }
          
          .benefit-item {
            padding: 12px 15px;
          }
          
          .benefit-icon {
            font-size: 1.1rem;
          }
          
          .benefit-item span {
            font-size: 0.9rem;
          }
          
          .whatsapp-contact {
            padding: 12px 25px;
            font-size: 1rem;
          }
        }

        /* Mobile Landscape */
        @media (max-width: 576px) {
          .rooftop-hero {
            padding: 50px 15px;
          }
          
          .rooftop-hero h1 {
            font-size: 1.8rem;
          }
          
          .rooftop-hero p {
            font-size: 0.95rem;
          }
          
          .hero-icon {
            font-size: 2rem;
          }
          
          .hero-stats {
            gap: 12px;
          }
          
          .stat {
            padding: 6px 10px; /* Reduced padding */
          }
          
          .stat-number {
            font-size: 1.3rem; /* Reduced from 1.5rem */
          }
          
          .stat-label {
            font-size: 0.65rem; /* Reduced from 0.75rem */
          }
          
          .section-header h2 {
            font-size: 1.6rem;
          }
          
          .section-header p {
            font-size: 0.9rem;
          }
          
          .rt-card {
            padding: 18px;
          }
          
          .card-icon {
            width: 50px;
            height: 50px;
            font-size: 1.4rem;
          }
          
          .rt-card h3 {
            font-size: 1rem;
          }
          
          .rt-card p {
            font-size: 0.85rem;
          }
          
          .rt-benefits {
            padding: 25px 15px;
          }
          
          .rt-benefits h2 {
            font-size: 1.5rem;
          }
          
          .benefits-grid {
            grid-template-columns: 1fr;
            gap: 12px;
          }
          
          .benefit-item {
            padding: 10px 12px;
          }
          
          .benefit-icon {
            font-size: 1rem;
          }
          
          .benefit-item span {
            font-size: 0.85rem;
          }
          
          .whatsapp-contact {
            padding: 10px 20px;
            font-size: 0.9rem;
          }
        }

        /* Small Mobile */
        @media (max-width: 400px) {
          .rooftop-hero {
            padding: 40px 10px;
          }
          
          .rooftop-hero h1 {
            font-size: 1.6rem;
          }
          
          .hero-stats {
            flex-direction: column;
            width: 100%;
          }
          
          .stat {
            width: 100%;
            max-width: 200px;
            margin: 0 auto;
            padding: 6px 10px; /* Reduced padding */
          }
          
          .stat-number {
            font-size: 1.2rem; /* Reduced from 1.3rem */
          }
          
          .stat-label {
            font-size: 0.6rem; /* Reduced from 0.65rem */
          }
          
          .rooftop-container {
            padding: 0 10px;
          }
          
          .rt-card {
            padding: 15px;
          }
          
          .rt-benefits {
            padding: 20px 10px;
          }
        }
      `}</style>
    </section>
  );
};

export default RooftopSolar;